var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 93,
    viewBox: "0 0 71 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5229",
    "data-name": "Group 5229",
    transform: "translate(-998.512 -2532.115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5228",
    "data-name": "Group 5228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5227",
    "data-name": "Group 5227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5226",
    "data-name": "Group 5226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5225",
    "data-name": "Group 5225"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5224",
    "data-name": "Group 5224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4635",
    "data-name": "Group 4635",
    transform: "translate(998.512 2532.115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NewGroupe0",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NewGroup3-0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4002",
    "data-name": "Group 4002"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5223",
    "data-name": "Group 5223"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5717",
    "data-name": "Path 5717",
    d: "M315.271,229.924h-9.995a3.091,3.091,0,0,0-3.086,3.086v9.995H274.624c-.035,0-.07-.044-.07-.105V219.622h26.653a4.03,4.03,0,0,0,4.024-4.024V200.333a4.03,4.03,0,0,0-4.024-4.024H274.555V186.086c0-.061.035-.105.07-.105H315.2c.035,0,.07.044.07.105v43.838Zm-10.1,10.968V233a.113.113,0,0,1,.105-.105h7.891l-8,8ZM266.322,216.65a1.057,1.057,0,0,1-1.043-1.043V200.334a1.057,1.057,0,0,1,1.043-1.043h34.886a1.059,1.059,0,0,1,1.043,1.052v15.264a1.057,1.057,0,0,1-1.043,1.043Zm51.93-30.564A3.072,3.072,0,0,0,315.2,183H274.624a3.072,3.072,0,0,0-3.051,3.086v10.223H266.33a4.03,4.03,0,0,0-4.024,4.024V215.6a4.03,4.03,0,0,0,4.024,4.024h5.243v23.269a3.072,3.072,0,0,0,3.051,3.086H303.68a.851.851,0,0,0,.149-.009c.026,0,.061-.009.088-.009s.035-.009.061-.009l.105-.026c.009,0,.026-.009.035-.009.035-.009.07-.026.105-.035.009,0,.017-.009.035-.009.035-.017.061-.026.1-.044.009-.009.026-.009.035-.017.026-.017.061-.035.088-.053.009-.009.026-.017.035-.026.026-.017.052-.044.079-.061.009-.009.026-.018.035-.027.035-.035.07-.061.105-.1l13.081-13.081a1.049,1.049,0,0,0,.1-.105c.017-.017.026-.035.044-.053a.277.277,0,0,0,.044-.061c.017-.018.026-.044.044-.061a.379.379,0,0,0,.035-.061c.009-.026.026-.044.035-.07s.018-.044.026-.061.017-.044.026-.07.017-.044.026-.07.009-.044.017-.07.009-.052.018-.07a.245.245,0,0,0,.009-.079c0-.017.009-.044.009-.061a.855.855,0,0,0,.009-.149V186.086Z",
    transform: "translate(-262.306 -183)",
    fill: "#313830"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4003",
    "data-name": "Group 4003",
    transform: "translate(12.142 21.922)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5718",
    "data-name": "Path 5718",
    d: "M322.074,290.908h2.8a7.423,7.423,0,0,1,1.621.14,1.5,1.5,0,0,1,.872.49,1.542,1.542,0,0,1,.274.974v1.324a1.738,1.738,0,0,1-.3,1.077,1.633,1.633,0,0,1-.937.549,7.355,7.355,0,0,1-1.728.161h-.926V297.9h-1.68Zm2.746,3.564a1.976,1.976,0,0,0,.926-.156.565.565,0,0,0,.269-.533v-1.12a.438.438,0,0,0-.258-.452,2.8,2.8,0,0,0-.958-.108h-1.044v2.369Z",
    transform: "translate(-322.074 -290.908)",
    fill: "#313830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5719",
    "data-name": "Path 5719",
    d: "M355.3,290.908h2.972a7.9,7.9,0,0,1,1.938.188,1.8,1.8,0,0,1,1.044.652,2.158,2.158,0,0,1,.334,1.281v2.843a2.093,2.093,0,0,1-.312,1.233,1.709,1.709,0,0,1-1.023.614,8.521,8.521,0,0,1-1.97.178H355.3Zm2.907,5.793a6.741,6.741,0,0,0,1.039-.059.856.856,0,0,0,.506-.232.785.785,0,0,0,.156-.538V293a.713.713,0,0,0-.393-.695,2.938,2.938,0,0,0-1.254-.2h-1.281v4.6Z",
    transform: "translate(-348.554 -290.908)",
    fill: "#313830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5720",
    "data-name": "Path 5720",
    d: "M392.935,290.908h5.437v1.2h-3.757v1.712h3.4v1.2h-3.4V297.9h-1.68Z",
    transform: "translate(-378.539 -290.908)",
    fill: "#313830"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.b7f641302f1991fcebbf32294c94962d.svg";
export { ForwardRef as ReactComponent };